var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMp3Disable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.5 0H2.5C1.39543 0 0.5 0.89543 0.5 2V43C0.5 44.1046 1.39543 45 2.5 45H43.5C44.6046 45 45.5 44.1046 45.5 43V2C45.5 0.89543 44.6046 0 43.5 0Z",
    fill: "#A9B6CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2083 11.375C22.656 11.375 22.2083 11.8227 22.2083 12.375V12.6667V17.8333V24.545C22.2083 25.3159 21.346 25.8218 20.5889 25.6762C20.2725 25.6154 19.9498 25.5841 19.625 25.5833C18.2547 25.5833 16.9405 26.1277 15.9716 27.0966C15.0027 28.0656 14.4583 29.3797 14.4583 30.75C14.4583 32.1203 15.0027 33.4344 15.9716 34.4034C16.9405 35.3723 18.2547 35.9167 19.625 35.9167C20.9953 35.9167 22.3094 35.3723 23.2784 34.4034C24.2473 33.4344 24.7916 32.1203 24.7916 30.75V18.8333C24.7916 18.281 25.2394 17.8333 25.7916 17.8333H31.5416C32.0939 17.8333 32.5416 17.3856 32.5416 16.8333V12.375C32.5416 11.8227 32.0939 11.375 31.5416 11.375H23.2083Z",
    fill: "#E2E8EF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMp3Disable);
export default __webpack_public_path__ + "static/media/ic_mp3_disable.0721a3ea90016f4f3e07d588cba0be14.svg";
export { ForwardRef as ReactComponent };